import { getRouteData } from 'ha/modules/Hermes';
import { GlobalState } from 'ha/types/store';
import { Blog } from '../types';

interface HermesData {
  blogList?: Blog[];
}

export default (state: GlobalState) => {
  const data: HermesData | undefined = getRouteData(state);

  if (!data || !data.blogList) {
    return [];
  }

  return data.blogList.slice(0, 3);
};
